// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "commons" + "-" + "0b4c5ba9377d6c4f" + ".js";
};